__turbopack_context__.v({
  "action": "index-module__5QgK6a__action",
  "content": "index-module__5QgK6a__content",
  "footer": "index-module__5QgK6a__footer",
  "icon": "index-module__5QgK6a__icon",
  "language": "index-module__5QgK6a__language",
  "root": "index-module__5QgK6a__root",
});
